import { ReactNode } from "react";

import ConfirmationModal from "../ConfirmationModal";
import { ConfirmationModalProps } from "../ConfirmationModal/types";
import { ConfirmationModalMessage } from "../ConfirmationModal/Message";

type DeleteConfirmationModalWithNameProps = {
  name: string;
  children?: never;
};

type DeleteConfirmationModalWithChildrenProps = {
  name?: never;
  children: ReactNode;
};

type DeleteConfirmationModalProps = Pick<
  ConfirmationModalProps,
  | "onConfirm"
  | "isLoading"
  | "isDismissable"
  | "confirmationButtonLabel"
  | "title"
  | "onClose"
  | "isConfirmationDisabled"
  | "size"
> &
  (DeleteConfirmationModalWithNameProps | DeleteConfirmationModalWithChildrenProps);

const DeleteConfirmationModal = ({
  confirmationButtonLabel = "Delete",
  name,
  children,
  ...rest
}: DeleteConfirmationModalProps) => {
  const content = children || (
    <ConfirmationModalMessage>
      Are you sure you want to delete <strong>{name}</strong>?
    </ConfirmationModalMessage>
  );

  return (
    <ConfirmationModal confirmationButtonLabel={confirmationButtonLabel} {...rest}>
      {content}
    </ConfirmationModal>
  );
};

DeleteConfirmationModal.displayName = "DS.DeleteConfirmationModal";

export default DeleteConfirmationModal;
